import { Injectable } from '@angular/core';
import _ from 'lodash';
import { ImageConstants } from './image-constants';

@Injectable()
export class Constants {
  private readonly Spindles: BasicObject[];
  private readonly Holders: BasicObject[];
  private readonly OperationTypes: BasicObject[];
  private readonly ToolPathTypes: object[] = [{}, {}, {}, {}];
  private readonly ToolPaths: object[];
  private readonly ToolPathSelections: ToolPathSelections[];
  private readonly MillBits: MillBit[];
  private readonly recommendationAdjustmentOption: BasicObject[];
  readonly EMAIL_REGEX: RegExp;
  readonly DOMESTIC_PHONE_REGEX: RegExp; // US and Canada
  readonly INTERNATIONAL_PHONE_REGEX: RegExp;
  readonly PASSWORD_REGEX: RegExp;
  readonly NUMBER_ONLY_REGEX: RegExp;
  readonly DECIMAL_ONLY_REGEX: RegExp;

  constructor(public imageConstants: ImageConstants) {
    this.Spindles = [
      new BasicObject('CV30', 'CV30'),
      new BasicObject('CV40', 'CV40'),
      new BasicObject('CV45', 'CV45'),
      new BasicObject('CV50', 'CV50'),
      new BasicObject('CV60', 'CV60'),
      new BasicObject('BT30', 'BT30'),
      new BasicObject('BT35', 'BT35'),
      new BasicObject('BT40', 'BT40'),
      new BasicObject('BT50', 'BT50'),
      new BasicObject('HSK25', 'HSK25'),
      new BasicObject('HSK32', 'HSK32'),
      new BasicObject('HSK40', 'HSK40'),
      new BasicObject('HSK50', 'HSK50'),
      new BasicObject('HSK63', 'HSK63'),
      new BasicObject('HSK80', 'HSK80'),
      new BasicObject('HSK100', 'HSK100'),
      new BasicObject('HSK125', 'HSK125'),
      new BasicObject('NMTB30', 'NMTB30'),
      new BasicObject('NMTB40', 'NMTB40'),
      new BasicObject('NMTB50', 'NMTB50')
    ];

    this.Holders = [
      new BasicObject('Weldon', 'Weldon'),
      new BasicObject('DA Collet', 'DA Collet'),
      new BasicObject('ER Collet', 'ER Collet'),
      new BasicObject('TG Collet', 'TG Collet'),
      new BasicObject('Shrink-Fit', 'Shrink-Fit'),
      new BasicObject('Press-Fit', 'Press-Fit'),
      new BasicObject('Hydraulic', 'Hydraulic'),
      new BasicObject('Milling Chuck', 'Milling Chuck')
    ];

    this.OperationTypes = [new BasicObject('General Milling', 'General Milling')];

    this.ToolPaths = [
      /*0*/ new Toolpath(
        'Zig-Zag Tool Path',
        'Zig-Zag Tool Path',
        this.imageConstants.zigZagLabeled,
        this.imageConstants.zigZagUnlabeled,
        'Equidistant parallel lines that fit with the cut area.*',
        this.ToolPathTypes[0],
        true
      ), //cross relational reference
      /*1*/ new Toolpath(
        'Trochoidal Tool Path',
        'Trochoidal Tool Path',
        this.imageConstants.trochoidalLabeled,
        this.imageConstants.trochoidalUnlabeled,
        'Rounded offsets with arcs that pick out slots and corners.',
        this.ToolPathTypes[1],
        true
      ),
      /*2*/ new Toolpath(
        'Full Slotting',
        'Full Slotting',
        this.imageConstants.fullSlottingLabeled,
        this.imageConstants.fullSlottingUnlabeled,
        'The endmill diameter is equivalent to the slot width and the path follows the centerline of the slot.',
        this.ToolPathTypes[2],
        true
      ),
      /*3*/ new Toolpath(
        'Finishing',
        'Finishing',
        this.imageConstants.finishingLabeled,
        this.imageConstants.finishingUnlabeled,
        'Follows the part profile after most of the material has been removed during a roughing operation.',
        this.ToolPathTypes[3],
        true
      ),
      /*4*/ new Toolpath(
        'Offset Tool Path',
        'Offset Tool Path',
        this.imageConstants.offsetToolLabeled,
        this.imageConstants.offsetToolUnlabeled,
        'Equidistant offsets following the shape of the past profile.',
        this.ToolPathTypes[0],
        true
      ),
      /*5*/ new Toolpath(
        'Looping Tool Path',
        'Looping Tool Path',
        this.imageConstants.LoopingToolPathLabeled,
        this.imageConstants.LoopingToolPathUnlabeled,
        'Loops expanding outward to part profile with smaller arcs picking out corners.',
        this.ToolPathTypes[1],
        true
      ),
      /*6*/ new Toolpath(
        'Chamfering',
        'Chamfering',
        this.imageConstants.toolPathDefault,
        this.imageConstants.toolPathDefault,
        'Chamfering',
        this.ToolPathTypes[4],
        false
      ),
      /*7*/ new Toolpath(
        'Trochoidal Slotting',
        'Trochoidal Slotting',
        this.imageConstants.trochoidalSlottingLabeled,
        this.imageConstants.trochoidalSlottingUnlabeled,
        'The endmill diameter is less than the slot width so it can follow a series of arcs. **',
        this.ToolPathTypes[2],
        true
      ),
      /*8*/ new Toolpath(
        '3D Surfacing',
        '3D Surfacing',
        this.imageConstants.toolPathDefault,
        this.imageConstants.toolPathDefault,
        '3D Surfacing',
        this.ToolPathTypes[4],
        false
      )
    ];

    this.ToolPathTypes = [
      /*0*/ new ToolPathType('Traditional Roughing', 'Traditional Roughing', [this.ToolPaths[0], this.ToolPaths[4]]), //cross relational reference
      /*1*/ new ToolPathType('High Efficiency Roughing', 'High Efficiency Roughing', [
        this.ToolPaths[1],
        this.ToolPaths[5]
      ]),
      /*2*/ new ToolPathType('Slotting', 'Slotting', [this.ToolPaths[2], this.ToolPaths[7]]),
      /*3*/ new ToolPathType('Finishing', 'Finishing', [this.ToolPaths[3]])
    ];

    this.ToolPathSelections = [
      /*0*/ new ToolPathSelections(
        'High Efficiency Milling',
        'High Efficiency Milling',
        [this.ToolPaths[1], this.ToolPaths[5]],
        true
      ),
      /*1*/ new ToolPathSelections('Finishing', 'Finishing', [this.ToolPaths[3]], true),
      /*2*/ new ToolPathSelections('Full Slotting', 'Full Slotting', [this.ToolPaths[2]], true),
      /*3*/ new ToolPathSelections(
        'Traditional Roughing',
        'Traditional Roughing',
        [this.ToolPaths[0], this.ToolPaths[4]],
        true
      ),
      /*4*/ new ToolPathSelections('Trochoidal Slotting', 'Trochoidal Slotting', [this.ToolPaths[7]], true),
      /*5*/ new ToolPathSelections('Helical Plunge', 'Helical Plunge', [], true),
      /*6*/ new ToolPathSelections('Chamfering', 'Chamfering', [this.ToolPaths[6]], false),
      /*7*/ new ToolPathSelections('3D Surfacing', '3D Surfacing', [this.ToolPaths[8]], false)
    ];

    this.MillBits = [
      new MillBit('Square', 'Square', 35, 80, this.imageConstants.mapSquareEndMillPadded, 42, 80),
      new MillBit('Chamfer', 'Chamfer', 34, 23, this.imageConstants.mapChamferMillPadded, 43, 23),
      new MillBit('Ball-Nosed', 'Ball-Nosed', 36, 79, this.imageConstants.mapBallEndMillPadded, 42, 80),
      new MillBit('Bull-Nosed', 'Bull-Nosed', 36, 79, this.imageConstants.mapBullNosedPadded, 42, 80)
    ];

    this.recommendationAdjustmentOption = [
      new BasicObject('IPM Inside Corner', 'IPM Inside Corner'),
      new BasicObject('RDOC Inside Corner', 'RDOC Inside Corner')
    ];

    this.EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.DOMESTIC_PHONE_REGEX = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
    this.INTERNATIONAL_PHONE_REGEX = /^\+?([-\s\.\(\)]*\d[-\s\.\(\)]*){7,20}$/;
    this.PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/;

    this.NUMBER_ONLY_REGEX = /^[0-9]*$/;
    this.DECIMAL_ONLY_REGEX = /^[+-]?(\d*\.)?\d+$/;
  }

  getSpindles = (): BasicObject[] => {
    return this.Spindles;
  };

  getHolders = (): BasicObject[] => {
    return this.Holders;
  };

  getOperationTypes = (): BasicObject[] => {
    return this.OperationTypes;
  };

  getToolPathTypes = (): object[] => {
    return this.ToolPathTypes;
  };

  getToolPaths = (): object[] => {
    return this.ToolPaths;
  };

  getToolPathSelections = (): ToolPathSelections[] => {
    return this.ToolPathSelections;
  };

  getMillBits = (): MillBit[] => {
    return this.MillBits;
  };

  getMillBitByName = (name: string): MillBit => {
    return _.find(this.MillBits, millBit => {
      return millBit.name.toLowerCase() === name.toLowerCase();
    });
  };

  getMillBit = (index: number): MillBit => {
    return this.MillBits[index];
  };

  getRecommendationAdjustmentOption = (): BasicObject[] => {
    return this.recommendationAdjustmentOption;
  };
}

export class BasicObject {
  private name: string;
  private value: string;
  constructor(name: string, value?: string) {
    this.name = name;
    this.value = value || undefined;
  }

  getName = (): string => {
    return this.name;
  };

  getValue = (): string => {
    return this.value;
  };
}

export class ToolPathSelections extends BasicObject {
  private readonly toolPaths: object[];
  public applicable: boolean; // this will be changing, so let it be public for easy operations,
  constructor(name: string, value: string, toolPaths: object[], applicable: boolean) {
    super(name, value);
    this.toolPaths = toolPaths;
    this.applicable = applicable;
  }

  setApplicable = (applicable: boolean) => {
    this.applicable = applicable;
  };

  getApplicable = (): boolean => {
    return this.applicable;
  };

  getToolPaths = (): object[] => {
    return this.toolPaths;
  };
}

class ToolPathType extends BasicObject {
  private readonly toolPaths: object[];
  constructor(name: string, value: string, toolPaths: object[]) {
    super(name, value);
    this.toolPaths = toolPaths;
  }

  getToolPaths = (): object[] => {
    return this.toolPaths;
  };
}

export class Toolpath extends BasicObject {
  public mapMode: number;
  public operationKey: number;
  public operationToolPathTitle?: string;
  public operationToolPathDescription?: string;
  public operationImage?: string;
  public operationImageAssetForParameterSection?: string;
  private unLabledImage: string;
  private labledImage: string;
  private description: string;
  private type: object;
  public applicable: boolean; // this will be changing, so let it be public for easy operations
  public strategies: Strategy[];
  constructor(
    name: string,
    value: string,
    labledImage: string,
    unLabledImage: string,
    description: string,
    type: object,
    applicable: boolean
  ) {
    super(name, value);
    this.unLabledImage = unLabledImage;
    this.labledImage = labledImage;
    this.description = description;
    this.type = type;
    this.applicable = applicable;
  }

  getUnLabledImage = (): string => {
    return this.unLabledImage;
  };

  getLabledImage = (): string => {
    return this.labledImage;
  };

  getDescription = (): string => {
    return this.description;
  };

  getType = (): object => {
    return this.type;
  };

  setApplicable = (applicable: boolean) => {
    this.applicable = applicable;
  };

  getApplicable = (): boolean => {
    return this.applicable;
  };
}

export class Strategy extends BasicObject {
  operationName: string;
  strategyId: number;
  mapMode: number;
  operationKey: number;
  operationImageAssetForParameterSection: string;
  constructor(
    name: string,
    value: string,
    operationName: string,
    strategyId: number,
    mapMode: number,
    operationKey: number,
    operationImageAssetForParameterSection: string
  ) {
    super(name, value);
    this.operationName = operationName;
    this.strategyId = strategyId;
    this.mapMode = mapMode;
    this.operationKey = operationKey;
    this.operationImageAssetForParameterSection = operationImageAssetForParameterSection;
  }
}

export class MillBit extends BasicObject {
  private percentageWidth: number; // there will be numbers directly from developer tool. its the width MAX of image of the bit
  private percentageHeight: number; // there will be numbers directly from developer tool,  its the width MAX of image of the bit
  private image: string;
  private mobilePercentageWidth: number;
  private mobilePercentageHeight: number;
  constructor(
    name: string,
    value: string,
    percentageWidth: number,
    percentageHeight: number,
    image: string,
    mobilePercentageWidth: number,
    mobilePercentageHeight: number
  ) {
    super(name, value);
    this.percentageWidth = percentageWidth;
    this.percentageHeight = percentageHeight;
    this.image = image;
    this.mobilePercentageWidth = mobilePercentageWidth;
    this.mobilePercentageHeight = mobilePercentageHeight;
  }

  getPercentWidth = (): number => {
    return this.percentageWidth;
  };

  getPercentHeight = (): number => {
    return this.percentageHeight;
  };

  getImage = (): string => {
    return this.image;
  };

  getMobilePercentageWidth = (): number => {
    return this.mobilePercentageWidth;
  };

  getMobilePercentageHeight = (): number => {
    return this.mobilePercentageHeight;
  };
}
